import { render, staticRenderFns } from "./extractConfigurationItemList.vue?vue&type=template&id=673e5abb&scoped=true"
import script from "./extractConfigurationItemList.vue?vue&type=script&lang=js"
export * from "./extractConfigurationItemList.vue?vue&type=script&lang=js"
import style0 from "./extractConfigurationItemList.vue?vue&type=style&index=0&id=673e5abb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673e5abb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('673e5abb')) {
      api.createRecord('673e5abb', component.options)
    } else {
      api.reload('673e5abb', component.options)
    }
    module.hot.accept("./extractConfigurationItemList.vue?vue&type=template&id=673e5abb&scoped=true", function () {
      api.rerender('673e5abb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/extractConfigurationItem/extractConfigurationItemList.vue"
export default component.exports